import axios from 'axios';
import {
  ACCESS_TOKEN,
  config,
} from '../config/Config';

// Update chit status for a member's plan
export function updateChitStatus(email, planId, status) {
  return instance.put(
    `/gvg/secure/admin/updateChitStatus`,
    {
      email: email,      
      planId: planId,  
      status: status     
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem(ACCESS_TOKEN)
          ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
          : null,
      },
    }
  );
}

export function updateMoneyChitStatus(email, planId, newStatus) {
  return instance.put(`gvg/secure/admin/updateMoneyChitStatus`, {
    email,
    planId,
    status: newStatus,
  }, {
    headers: {
      'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        : null,
    },
  });
}
export function updatePersonalLoanStatus(email, planId, newStatus) {
  return instance.put(`gvg/secure/admin/updatePersonalLoanStatus`, {
    email,
    planId,
    status: newStatus,
  }, {
    headers: {
      'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        : null,
    },
  });
}


// money chit payment update 
export function updateInstallmentMoneyChitPayment(paymentRequest) {
  return instance.put(`/gvg/secure/admin/updateInstallmentMoneyChitPayment`, paymentRequest, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        : null,
    },
  });
}
export function updatePersonalLoanPayment(paymentRequest) {
  return instance.put(`/gvg/secure/admin/updatePersonalLoanPayment`, paymentRequest, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        : null,
    },
  });
}



export function updateMoneyChitSettlement(withdrawalRequest) {
  return instance.post(`/gvg/secure/admin/updateMoneyChitSettlement`,
  
    withdrawalRequest
  , {
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        : null,
    },
  });
}
export function updatePersonalLoanSettlement(withdrawalRequest) {
  return instance.post(`/gvg/secure/admin/updatePersonalLoanSettlement`,

    withdrawalRequest
  , {
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        : null,
    },
  });
}


export function updateGoldChitSettlement(withdrawalRequest) {
  return instance.put(
    `/gvg/secure/admin/updateGoldChitSettlement`,withdrawalRequest,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem(ACCESS_TOKEN)
          ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
          : null,
      },
    }
  );
}
export function getGoldChitWithdrawals(email, planId = null) {
  return instance.get(
    `/gvg/secure/admin/getGoldChitWithdrawals`,
    {
      params: {
        email: email,
        planId: planId
      },
      headers: {
        Authorization: localStorage.getItem(ACCESS_TOKEN)
          ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
          : null,
      },
    }
  );
}





// Update installment payment for a member's plan
export function updateInstallmentPayment(email, planId, installmentNumber, paidAmount, paidFrom, paidDate, transactionId) {
  const formData = new FormData();
  formData.append('email', email);
  formData.append('planId', planId);
    const paymentRequest = {
      email,
      planId,
      installmentNumber,
      paidAmount,
      paidFrom,
      paidDate,
      transactionId,
    };
    return instance.put(`/gvg/secure/admin/updateInstallmentPayment`, paymentRequest, {
      headers: {
        'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        : null,
    },
  });
}




// -- Axios

const instance = axios.create({
  baseURL: config.url.API_BASE_URL,
});

export function saveOrderDataBff(orderRequest) {
  return instance.post("/gvg/order/placeOrder", orderRequest,{
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? "Bearer " + localStorage.getItem(ACCESS_TOKEN)
        : null,
    },
    
  });
  
}
export function saveGoldLoanDataBff(loanRequest) {
  return instance.put("/gvg/common/updateAppliedFor", loanRequest,{
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? "Bearer " + localStorage.getItem(ACCESS_TOKEN)
        : null,
    },
    
  });
  
}

export function savePersonalLoanDataBff(loanRequest) {
  return instance.post("gvg/plan/applyPersonalLoan", loanRequest,{
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? "Bearer " + localStorage.getItem(ACCESS_TOKEN)
        : null,
    },
    
  });
  
}
export function retrieveProfileData(email) {
  // alert("userName!!!"+clientUserName)
  return instance.get(`/gvg/common/profileDataByEmail/${email}`, {
    headers: {
      'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        : null,
    },
  });
}

export function getAllPersonalLoanDataBff(startDate, endDate, category) {
  return instance.get(`/gvg/secure/admin/getPersonalLoanApplications/${startDate}/${endDate}/${category}`, {
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? "Bearer " + localStorage.getItem(ACCESS_TOKEN)
        : null,
    },
  });
}

export function retrieveGvgOrder(email) {
  // alert("userName!!!"+clientUserName)
  return instance.get(`/gvg/order/orders/${email}`, {
    headers: {
      'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        : null,
    },
  });
}
export function retrieveGvgPlan(email) {
  // alert("userName!!!"+clientUserName)
  return instance.get(`/gvg/plan/plan/${email}`, {
    headers: {
      'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        : null,
    },
  });
}
export function savePlanDataBff(orderRequest) {
  return instance.post("gvg/plan/choosePlan", orderRequest,{
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? "Bearer " + localStorage.getItem(ACCESS_TOKEN)
        : null,
    },
    
  });
  
}
export function saveGoldLoanData(loanRequest) {
  return instance.post("gvg/plan/choosePlan", loanRequest,{
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? "Bearer " + localStorage.getItem(ACCESS_TOKEN)
        : null,
    },
    
  });
  
}
export function retrieveUserData() {
  return instance.get("gvg/order/dashboard/pupil/order", {
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? "Bearer " + localStorage.getItem(ACCESS_TOKEN)
        : null,
    },
  });
}

export function getGvgOrder() {
 
  return instance.get(
    `/gvg/secure/admin/dashboard/users/order`,
    {
      headers: {
        'Content-type': 'application/json',
        Authorization: localStorage.getItem(ACCESS_TOKEN) ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` : null,
      },
    },
  );
}
export function getGvgData() {
 
  return instance.get(
    `/gvg/secure/admin/dashboard/users/gvg`,
    {
      headers: {
        'Content-type': 'application/json',
        Authorization: localStorage.getItem(ACCESS_TOKEN) ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` : null,
      },
    },
  );
}

export function getGvgPlan() {
 
  return instance.get(
    `/gvg/secure/admin/dashboard/users/plan`,
    {
      headers: {
        'Content-type': 'application/json',
        Authorization: localStorage.getItem(ACCESS_TOKEN) ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` : null,
      },
    },
  );
}
export function getGvgOrderPlan() {
 
  return instance.get(
    `/gvg/secure/admin/dashboard/users/orderAndPlan`,
    {
      headers: {
        'Content-type': 'application/json',
        Authorization: localStorage.getItem(ACCESS_TOKEN) ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` : null,
      },
    },
  );
}
export function goldchitOnboard(orgEmail) {
  console.log("Fetching OrgGameData for user:", orgEmail); // Log the userName
  return instance.get(`/gvg/public/idp/goldchitOnboard/${orgEmail}`, {
    headers: {
      'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        : null,
    },
  });
}
export function goldChitOnboardByDateRange(category,startDate,endDate) {
  console.log("Fetching OrgGameData for user:", startDate,endDate); 
  return instance.get(`/gvg/common/getGoldChitOnboardByDateRange/${category}/${startDate}/${endDate}`, {
    headers: {
      'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        : null,
    },
  });
}

export function deleteGoldChit(chitId) {
  console.log("Deleting Gold Chit with ID:", chitId);
  return instance.delete(`/gvg/admin/deleteGoldChit/${chitId}`, {
    headers: {
      'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        : null,
    },
  });
}

export function chitOnboardByDateRange(startDate, endDate, category) {
    if (!category || typeof category !== 'string') {
        console.error("Error: Category is missing or invalid.");
        return Promise.reject(new Error("Category is missing or invalid."));
    }

    console.log("Fetching OrgGameData for user:", startDate, endDate, category);
    return instance.get(`/gvg/common/getChitOnboardByDateRange/${startDate}/${endDate}/${category}`, {
        headers: {
            'Content-type': 'application/json',
            Authorization: localStorage.getItem(ACCESS_TOKEN)
                ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
                : null,
        },
    });
}



export function joinGoldChit(goldChitJoinRequest) {
  return instance.post("gvg/plan/joinGoldChit", goldChitJoinRequest,{
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? "Bearer " + localStorage.getItem(ACCESS_TOKEN)
        : null,
    },
    
  });
  
}

export function joinMoneyChit(payload) {
  return instance.post("gvg/plan/joinMoneyChit", payload,{
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? "Bearer " + localStorage.getItem(ACCESS_TOKEN)
        : null,
    },
    
  });
  
}


export const joinChit = (chitId) => {
  const token = localStorage.getItem("token");
  return axios.post(
    "/gvg/common/joinGoldChit",
    { chitId },
    { headers: { Authorization: `Bearer ${token}` } }
  );
};


export function getSinglePLData() {
 
  return instance.get(
    `/gvg/plan/dashboard/users/getSinglePLData`,
    {
      headers: {
        'Content-type': 'application/json',
        Authorization: localStorage.getItem(ACCESS_TOKEN) ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` : null,
      },
    },
  );
}


